<template>
  <v-container fluid>
    <div class="containerx mx-5">
      <v-row>
        <v-col cols="12">
          <div class="d-flex flex-row flex-grow-1 mt-3">
            <div class=" d-flex flex-column flex-grow-1">
              <h2 class="font font-weight-bold font-size-lg blue-grey--text">
                Exports &amp; Downloads
              </h2>
              <p class=" font font-weight-medium">
                Get access to all reports, view, customize and export them
              </p>
            </div>
          </div>
        </v-col>
        <v-col cols="12">
          <div class="d-flex flex-row flex-grow-1">
            <v-autocomplete
              :items="reports"
              item-text="name"
              item-value="id"
              label="Select the type of reports to download"
              class=" font ml-1 font-weight-medium font-size-sm"
              hide-details
              dense
              flat
              v-model="report"
              solo
              background-color="#e8e8e8"
            >
              <template #item="{item}">
                <span class=" font font-weight-medium font-size-sm">{{
                  item.name
                }}</span>
              </template>
              <template #selection="{item}">
                <v-chip class="box-shadow-light" label color="primary" small>
                  <span
                    class="font font-weight-medium"
                    style="font-size: 12px;"
                    >{{ item.name }}</span
                  >
                </v-chip>
              </template>
            </v-autocomplete>
            <div
              v-if="report === 'LUBES_GENERAL_MONTHLY_REPORTS'"
              class=" mx-1 d-flex flex-column"
            >
              <v-autocomplete
                :items="[...monthlyDates]"
                item-text="label"
                item-value="value"
                label="Choose Month/Duration"
                class=" font  font-weight-medium font-size-sm"
                dense
                flat
                v-model="lubesMonthlyDate"
                solo
                background-color="#e8e8e8"
              >
                <template #item="{item}">
                  <span
                    class=" text-uppercase font font-weight-medium font-size-sm"
                    >{{ item.label }}</span
                  >
                </template>
              </v-autocomplete>
            </div>
            <div v-else class="d-flex flex-column">
              <v-menu
                v-if="report !== 'CUSTOMERS_LIST'"
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                :return-value.sync="dates"
                transition="scale-transition"
                offset-y
                class="font font-weight-medium"
                min-width="auto"
                :nudge-left="80"
                :nudge-bottom="6"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-chip
                    v-model="dates"
                    v-bind="attrs"
                    v-on="on"
                    label
                    :close="dates.length === 2"
                    @click:close="dates = []"
                    :color="dates.length > 0 ? 'primary' : 'white'"
                    class="  font mx-1 text-uppercase font-weight-medium"
                    style="padding: 19px !important;"
                  >
                    <i class="material-icons-outlined font-size-md mr-2"
                      >event</i
                    >
                    {{ dates.length > 0 ? dateRangeText : "Choose date range" }}
                  </v-chip>
                </template>
                <v-date-picker
                  class="font font-weight-medium font-size-sm"
                  v-model="dates"
                  range
                >
                  <v-spacer></v-spacer>
                  <v-btn
                    small
                    class=" font font-weight-medium"
                    text
                    color="primary"
                    @click="(menu = false), (dates = [])"
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                    text
                    @click="filteredByDates"
                    class="font font-weight-medium"
                    color="primary"
                  >
                    OK
                  </v-btn>
                </v-date-picker>
              </v-menu>
              <v-autocomplete
                v-else
                :items="customerTypeList"
                label="Choose Option"
                class=" font ml-2 font-weight-medium font-size-sm"
                dense
                item-value="value"
                item-text="text"
                flat
                v-model="customerType"
                solo
                background-color="#e8e8e8"
              >
                <template #item="{item}">
                  <span
                    class=" text-uppercase font font-weight-medium font-size-sm"
                    >{{ item.text }}</span
                  >
                </template>
              </v-autocomplete>
            </div>
          </div>
        </v-col>
        <v-col cols="12">
          <div
            v-if="
              (report === 'CUSTOMERS_LIST' && records.length > 0) ||
                (records.length > 0 && dates.length > 1 && report !== null)
            "
            class="d-flex flex-column flex-grow-1"
          >
            <div
              v-if="report !== 'LUBE_SALES'"
              class="d-flex flex-row flex-grow-1 justify-end mb-2"
            >
              <v-btn
                outlined
                small
                @click.stop="downloadFile('xlsx')"
                color="success"
                class="mr-1"
                ><span
                  class=" font font-weight-medium font-size-sm text-uppercase"
                  >Export As Excel</span
                ></v-btn
              >
              <v-btn
                outlined
                @click.stop="downloadFile('csv')"
                small
                color="success"
                ><span
                  class=" font font-weight-medium font-size-sm text-uppercase"
                  >Export As CSV</span
                ></v-btn
              >
            </div>

            <v-data-table
              v-if="report !== 'LUBE_SALES'"
              :loading="listLoading"
              :items="records"
              :headers="titles"
              class=" font box-shadow-light font-weight-medium font-size-sm"
              :footer-props="{
                itemsPerPageOptions: [15, 30]
              }"
            >
              <template #item.productDeliveries="{item}">
                <template
                  v-if="
                    item.productDeliveries && item.productDeliveries.length > 0
                  "
                >
                  <div class="d-flex flex-row flex-wrap">
                    <v-chip
                      class="box-shadow-light mb-1"
                      label
                      x-small
                      v-for="(delivery, index) in item.productDeliveries"
                      :key="`del-${item.chequeNmber}-${index}`"
                    >
                      <span class=" font font-weight-medium font-size-sm"
                        >{{ delivery.branchName }}- Qty:
                        {{ delivery.quantity }}</span
                      >
                    </v-chip>
                  </div>
                </template>
              </template>
              <template #item.amount="{item}">
                <span> {{ item.amount | currencyFormat }}</span>
              </template>
              <template #item.cumulativeMonthlyTotal="{item}">
                <span> {{ item.cumulativeMonthlyTotal | currencyFormat }}</span>
              </template>
              <template #item.date="{item}">
                <span> {{ item.date | dateFormat }}</span>
              </template>
              <template #item.loadingDate="{item}">
                <span> {{ item.loadingDate | dateFormat }}</span>
              </template>
              <template #item.totalAmountBefore="{item}">
                <span> {{ item.totalAmountBefore | currencyFormat }}</span>
              </template>
              <template #item.currentTotalAmount="{item}">
                <span> {{ item.currentTotalAmount | currencyFormat }}</span>
              </template>
              <template #item.creditPurchasesAmount="{item}">
                <span> {{ item.creditPurchasesAmount | currencyFormat }}</span>
              </template>
            </v-data-table>
            <template v-else>
              <div class="d-flex flex-row flex-grow-1 flex-wrap">
                <div
                  v-for="(record, index) in records"
                  :key="index"
                  class="d-flex flex-grow-1 flex-column"
                >
                  <div class=" d-flex flex-row mt-1">
                    <v-chip
                      small
                      label
                      color="primary"
                      class="box-shadow-light"
                    >
                      <span class=" font font-weight-medium font-size-md">
                        {{ record[0] | dateFormat }}
                      </span>
                    </v-chip>
                  </div>
                  <v-data-table
                    :items="record[1]"
                    class=" font font-weight-medium  ma-1 font-size-sm box-shadow-light"
                    :headers="titles"
                  >
                  </v-data-table>
                </div>
              </div>
            </template>
          </div>
          <EmptyPage
            v-else
            :title="
              branchId !== null &&
              dates.length > 1 &&
              report !== null &&
              records.length === 0
                ? `No records found within this date range - ${dates.join('~')}`
                : 'Exports your reports for external use'
            "
            :subTitle="
              'Have a view of your chosen report, export them to excel, csv etc.'
            "
            imageWidth="200px"
            :image="require('@/assets/search.png')"
          >
            <template #action v-if="listLoading">
              <v-progress-circular indeterminate />
            </template>
          </EmptyPage>
        </v-col>
      </v-row>
    </div>
    <SnackBar
      :showSnackBar="showSnackBar"
      :message="message"
      :status="status"
    />
  </v-container>
</template>
<script>
import { mapGetters } from "vuex";
import moment from "moment";
import SnackBarMixins from "../../mixins/SnackBarMixins";
import { currencyFormat } from "../../filters/currencyFormat";
export default {
  name: "ExportsAndDownloads",
  components: {
    EmptyPage: () => import(`../../components/EmptyPage`),
    SnackBar: () => import(`../../components/SnackBar`)
  },
  computed: {
    ...mapGetters({
      listLoading: "getIsListLoading",
      records: "downloads/getAllReports",
      titles: "downloads/getTitles",
      profileDetails: "auth/getProfileDetails"
    }),
    dateRangeText() {
      return this.dates.join(" ~ ");
    }
  },
  filters: {
    dateFormat(value) {
      return moment(value).format("Do MMMM, YYYY");
    },
    currencyFormat
  },
  mixins: [SnackBarMixins],
  data() {
    return {
      menu: false,
      dates: [],
      branchId: null,
      report: null,
      monthlyDates: [],
      lubesMonthlyDate: null,
      customerType: "CUSTOMERS",
      customerTypeList: [
        { text: "INDIVIDUALS", value: "CUSTOMERS" },
        { text: "SUPPLIERS", value: "SUPPLIERS" },
        { text: "BUSINESSES", value: "BUSINESSES" }
      ],
      reports: [
        {
          id: "MD_BILLS",
          name: "MD BILLS",
          fileName: "MD-BILLS-",
          duration: {
            daily: false
          }
        },
        {
          id: "CUSTOMERS_LIST",
          name: "ALL CUSTOMERS LIST (SUPPLIERS, INDIVIDUALS, CUSTOMERS)",
          fileName: "CUSTOMERS",
          duration: {
            daily: false
          }
        },
        {
          id: "CONFIRMED_FUEL_DELIVERIES",
          name: "CONFIRMED FUEL DELIVERIES REPORT",
          fileName: "FUEL-DELIVERIES-",
          duration: {
            daily: false
          }
        },
        {
          id: "CARD_TRANSACTIONS",
          name: "CARD TRANSACTIONS REPORT",
          fileName: "CARD-TRANSACTIONS-",
          duration: {
            daily: false
          }
        }
      ]
    };
  },
  watch: {
    lubesMonthlyDate(value) {
      if (this.branchId && this.report) {
        this.dates = [value, value]; // set both start and end date to the same date
        this.$store.dispatch("exportReport/records", {
          startDate: value,
          endDate: value,
          action: this.report,
          branchId: this.branchId
        });
      }
    },
    report(value) {
      if (value === "LUBES_GENERAL_MONTHLY_REPORTS" && this.lubesMonthlyDate) {
        this.dates = [this.lubesMonthlyDate, this.lubesMonthlyDate];
        this.$store.dispatch("exportReport/records", {
          startDate: this.lubesMonthlyDate,
          endDate: this.lubesMonthlyDate,
          action: this.report,
          branchId: this.profileDetails?.branchId?.id
        });
        return;
      }
      if (value === "CUSTOMERS_LIST" && this.profileDetails?.branchId?.id) {
        this.$store.dispatch("downloads/records", {
          action: value,
          startDate: moment().format("YYYY-MM-DD"),
          endDate: moment().format("YYYY-MM-DD"),
          customerType: this.customerType,
          branchId: this.profileDetails?.branchId?.id
        });
        return;
      }

      if (this.profileDetails?.branchId?.id && this.dates.length === 2) {
        const [startDate, endDate] = this.dates;
        this.$store.dispatch("downloads/records", {
          startDate,
          endDate,
          action: value,
          ...(value === "DAILY_CREDIT_COLLECTIONS_BY_CUSTOMERS" && {
            type: "credit-collection" //indicator to just remove a field from the exported file
          }),
          branchId: this.profileDetails?.branchId?.id
        });
      }
    },

    dates(value) {
      if (
        this.report &&
        value.length === 2 &&
        this.profileDetails?.branchId?.id
      ) {
        const [startDate, endDate] = value;
        if (moment(startDate).isAfter(moment(endDate))) {
          this.$store.dispatch(
            "showSnackBar",
            {
              snackbar: true,
              message: `Invalid date range provided`,
              status: "red"
            },
            { root: true }
          );
          return;
        }
        this.$store.dispatch("downloads/records", {
          startDate,
          endDate,
          action: this.report,
          ...(this.report === "DAILY_CREDIT_COLLECTIONS_BY_CUSTOMERS" && {
            type: "credit-collection" //indicator to just remove a field from the exported file
          }),
          branchId: this.profileDetails?.branchId?.id
        });
      }
    },
    customerType(value) {
      if (this.profileDetails?.branchId?.id && this.report) {
        this.$store.dispatch("downloads/records", {
          action: this.report,
          customerType: value,
          startDate: moment().format("YYYY-MM-DD"),
          endDate: moment().format("YYYY-MM-DD"),
          branchId: this.profileDetails?.branchId?.id
        });
      }
    }
  },
  methods: {
    filteredByDates() {
      const [startDate, endDate] = this.dates;
      if (moment(startDate).isAfter(moment(endDate))) {
        this.$store.dispatch(
          "showSnackBar",
          {
            snackbar: true,
            message: `Invalid date range provided`,
            status: "red"
          },
          { root: true }
        );
        return;
      }
      this.$refs.menu.save(this.dates);
    },
    downloadFile(ext) {
      const file =
        this.reports.find(report => report.id === this.report)?.fileName ?? "";

      const [startDate, endDate] =
        this.dates.length > 0
          ? this.dates
          : [moment().format("YYYY-MM-DD"), moment().format("YYYY-MM-DD")]; // setting default dates array
      const fileName =
        this.dates.length > 0
          ? `${file}${startDate.replace(/-+/g, "")}-${endDate.replace(
              /-+/g,
              ""
            )}.${ext}`
          : `${this.customerType ?? file}.${ext}`;
      this.$store.dispatch("downloads/records", {
        startDate,
        endDate,
        action: this.report,
        branchId: this.profileDetails?.branchId?.id,
        customerType: this.customerType,
        download: true,
        fileName
      });
    }
  },
  created() {
    if (!this.profileDetails?.branchId?.id) {
      this.$store.dispatch("auth/me");
    }
    // this.monthlyDates = getMonthsBetweenDateRange(
    //   moment("01-2021", "MM-YYYY"),
    //   moment(new Date(), "MM-YYYY").add(3, "years")
    //);
  }
};
</script>
